<template>
  <div class="panel_shouyin">
    <!-- <div class="titleLine">
			<el-row>
				<el-col :span="6">
					
				</el-col>
				<el-col :span="6">
					
				</el-col>
				<el-col :span="2" :offset="22">
					<el-button @click="back" size="mini">返回</el-button>
				</el-col>
			</el-row>
		</div> -->
    <div class="con">
      <div class="L">
        <div class="label">设置体重</div>
        <el-input
          v-model="newestWeight"
          @input="changeNewestWeight"
          :rows="5"
          size="mini"
          style="width: 210px; margin-bottom: 10px"
          placeholder="请录入宠物最新体重"
        >
          <template slot="append">kg</template>
        </el-input>
        <div class="label">销售人员</div>
        <el-select
          v-model="saleManIdList"
          @change="changeSaleManIdList"
          multiple
          filterable
          placeholder="请选择"
          size="mini"
          style="width: 210px; margin-bottom: 10px"
        >
          <el-option
            v-for="item in staffList"
            :key="item._id"
            :label="item.basic_info.nick_name"
            :value="item._id + ',' + item.basic_info.nick_name"
          ></el-option>
        </el-select>
        <div class="label">疫苗驱虫</div>
        <el-radio-group
          v-model="type"
          @change="changeType"
          style="width: 210px; margin-bottom: 10px"
        >
          <el-radio style="margin-right: 25px" :label="'YM'">疫苗</el-radio>
          <el-radio style="margin-right: 25px" :label="'QC'">驱虫</el-radio>
        </el-radio-group>
        <div class="label">设置套餐类型</div>
        <el-radio-group
          v-if="type === 'QC'"
          v-model="buyWay2"
          @change="changeBuyWay"
          style="width: 230px; margin-bottom: 10px"
        >
          <span v-for="(item, index) in QCGroupTypeList" :key="index">
            <el-radio
              v-if="item.value === '0'"
              style="margin-right: 20px"
              :label="'0'"
              >满赠 </el-radio
            >
            <el-radio
              v-if="item.value === '1'"
              style="margin-right: 20px"
              :label="'1'"
              >折扣</el-radio
            >
            <el-radio
              v-if="item.value === '2'"
              style="margin-right: 20px"
              :label="'2'"
              >自定义</el-radio
            >
          </span>
        </el-radio-group>
        <el-radio-group
          v-else
          v-model="buyWay1"
          @change="changeBuyWay"
          style="width: 230px; margin-bottom: 10px"
        >
          <span v-for="(item, index) in YMGroupTypeList" :key="index">
            <el-radio
              v-if="item.value === '0'"
              style="margin-right: 20px"
              :label="'0'"
              >满赠</el-radio
            >
            <el-radio
              v-if="item.value === '1'"
              style="margin-right: 20px"
              :label="'1'"
              >折扣</el-radio
            >
            <el-radio
              v-if="item.value === '2'"
              style="margin-right: 20px"
              :label="'2'"
              >自定义</el-radio
            >
          </span>
        </el-radio-group>
        <div class="label">项目名称</div>
        <el-radio-group
          v-if="type === 'YM' && YMList.length"
          v-model="serviceId"
          @change="changeServiceId"
          style="width: 210px; margin-bottom: 10px"
        >
          <el-tooltip
            effect="dark"
            :content="item.title"
            placement="left"
            v-for="(item, index) in YMList"
            :key="index"
          >
            <el-radio
              :disabled="!newestWeight"
              style="margin-right: 25px; display: block; line-height: 22px"
              :label="item.groupId"
            >
              {{ item.title }}
            </el-radio>
          </el-tooltip>
        </el-radio-group>
        <!-- 驱虫 -->
        <el-radio-group
          v-if="type === 'QC' && QCList.length"
          v-model="serviceId"
          @change="changeServiceId"
          style="width: 210px; margin-bottom: 10px"
        >
          <el-tooltip
            effect="dark"
            :content="item.title"
            placement="left"
            v-for="(item, index) in QCList"
            :key="index"
          >
            <el-radio
              :disabled="!newestWeight"
              style="margin-right: 25px; display: block; line-height: 22px"
              :label="item.groupId"
            >
              {{ item.title }} 
            </el-radio>
          </el-tooltip>
        </el-radio-group>
        <!-- 疫苗 疫苗疫苗疫苗疫苗疫苗疫苗疫苗疫苗疫苗疫苗疫苗疫苗                   -->
        <div v-if="type === 'YM'">
          <div class="label">
            <span style="color: #f56c6c; font-size: 16px; margin-right: 3px"
              >*</span
            >
            选择三针疫苗
          </div>
          <el-select
            v-model="vaccine_plan"
            @change="changeVaccine_plan"
            placeholder="请选择"
            size="mini"
            style="width: 210px; margin-bottom: 10px"
          >
            <el-option
              v-for="item in servicePackage.vaccine_plan
                ? servicePackage.vaccine_plan.use_items
                : []"
              :key="item._id"
              :label="item.goods_name"
              :value="item.goods_id"
            ></el-option>
          </el-select>
          <div class="label">
            <span style="color: #f56c6c; font-size: 16px; margin-right: 3px"
              >*</span
            >
            选择狂犬疫苗
          </div>
          <el-select
            v-model="rabies_vaccine_plan"
            @change="changeRabies_vaccine_plan"
            placeholder="请选择"
            size="mini"
            style="width: 210px; margin-bottom: 10px"
          >
            <el-option
              v-for="item in servicePackage.rabies_vaccine_plan
                ? servicePackage.rabies_vaccine_plan.use_items
                : []"
              :key="item._id"
              :label="item.goods_name"
              :value="item.goods_id"
            >
            </el-option>
          </el-select>
          <div
            class="label"
            v-if="buyWay1 === '0' || buyWay1 === '1' || buyWay1 === '2'"
          >
            选择附加项
            <el-radio-group
              v-model="free1"
              @change="changeFree1"
              :disabled="
                !!servicePackage.additional_enhance_needle.charge_status
              "
              style="width: 130px; text-align: center"
            >
              <el-radio style="margin-right: 10px" :label="false"
                >收费</el-radio
              >
              <el-radio style="margin-right: 0px" :label="true">免费</el-radio>
            </el-radio-group>
          </div>
          <el-select
            v-if="buyWay1 === '0' || buyWay1 === '1' || buyWay1 === '2'"
            v-model="additional_enhance_needle"
            @change="changeAdditional_enhance_needle"
            multiple
            placeholder="请选择"
            size="mini"
            style="width: 210px; margin-bottom: 10px"
          >
            <el-option
              v-for="item in servicePackage.additional_enhance_needle
                ? servicePackage.additional_enhance_needle.use_items
                : []"
              :key="item._id"
              :label="item.goods_name"
              :value="item.goods_id"
            >
            </el-option>
          </el-select>
          <div
            class="label"
            v-if="buyWay1 === '0' || buyWay1 === '1' || buyWay1 === '2'"
          >
            选择检测项
            <el-radio-group
              v-model="free2"
              @change="changeFree2"
              :disabled="
                !!servicePackage.additional_medical_service_plan.charge_status
              "
              style="width: 130px; text-align: center"
            >
              <el-radio style="margin-right: 10px" :label="false"
                >收费</el-radio
              >
              <el-radio style="margin-right: 0px" :label="true">免费</el-radio>
            </el-radio-group>
          </div>
          <el-select
            v-if="buyWay1 === '0' || buyWay1 === '1' || buyWay1 === '2'"
            v-model="additional_medical_service_plan"
            @change="changeAdditional_medical_service_plan"
            multiple
            placeholder="请选择"
            size="mini"
            style="width: 210px; margin-bottom: 10px"
          >
            <el-option
              v-for="item in servicePackage.additional_medical_service_plan
                ? servicePackage.additional_medical_service_plan.use_items
                : []"
              :key="item._id"
              :label="item.goods_name"
              :value="item.goods_id"
            >
            </el-option>
          </el-select>
          <div v-if="buyWay1 === '1'">
            <div class="label">折扣</div>
            <el-input
              :value="$public.cheng(servicePackage.discount_rate, 100)"
              disabled
              size="mini"
              style="width: 210px; margin-bottom: 10px"
            >
              <template slot="append">折</template>
            </el-input>
          </div>
          <!-- <div v-if="buyWay1==='2'">
						<div class="label">最低折扣</div>
						<el-input v-model="YMDiscount" @input="changeYMDiscount" size="mini" style="width:210px;margin-bottom:5px;">
							<template slot="append">折</template>
						</el-input>
						<span style="display: block;font-size: 14px;color:#FF2A3A;">最低改价折扣为{{$public.cheng(servicePackage.discount_rate,100)}}折</span>
					</div> -->
          <div v-if="buyWay1 === '2'">
            <div class="label">自定义价格</div>
            <el-input
              v-model="YMCustomPrice"
              @input="changeYMCustomPrice"
              size="mini"
              style="width: 210px; margin-bottom: 5px"
            >
              <template slot="append">元</template>
            </el-input>
            <span style="display: block; font-size: 14px; color: #ff2a3a"
              >自定义价格区间 {{ servicePackage.min_price }} -
              {{ servicePackage.max_price }}元</span
            >
          </div>
        </div>
        <!-- 驱虫 驱虫驱虫驱虫驱虫驱虫驱虫驱虫驱虫驱虫                   -->
        <div v-if="type === 'QC' && QCPlanItem">
          <div class="label" v-if="buyWay2 === '0'">满赠方式</div>
          <el-radio-group
            v-if="buyWay2 === '0'"
            v-model="zengTime"
            @change="changeZengTime"
            style="width: 210px; padding: 0 5px; margin-bottom: 10px"
          >
            <el-radio
              style="margin-bottom: 5px"
              :label="item.times"
              v-for="(item, index) in servicePackage.buy_options"
              :key="index"
            >
              买{{ item.times }}次赠{{ item.give_times }}次
            </el-radio>
          </el-radio-group>
          <div class="label">
            <span v-if="must_use2==1" style="color: #f56c6c; font-size: 16px; margin-right: 3px"
              >*</span
            >
            设置体外驱虫项
          </div>
          <el-select
            v-model="outside"
            @change="changeOutside"
            placeholder="请选择"
            size="mini"
            style="width: 210px; margin-bottom: 10px"
          >
            <el-option
              v-for="item in QCPlanItem.outside_body_plan.plan_detail_items"
              :key="item.goods_id"
              :label="item.goods_name"
              :value="item.goods_id"
            >
            </el-option>
          </el-select>
          <el-input
            v-if="buyWay2 === '1' || buyWay2 === '2'"
            v-model="QCTime2"
            @input="changeQCTime2"
            size="mini"
            style="width: 210px; margin-bottom: 10px"
          >
            <template slot="append">次</template>
          </el-input>
          <div class="label">  <span v-if="must_use1==1" style="color: #f56c6c; font-size: 16px; margin-right: 3px"
              >*</span
            >  设置赠送体内驱虫项</div>
          <el-select
            v-model="inside"
            @change="changeInside"
            placeholder="请选择"
            size="mini"
            style="width: 210px; margin-bottom: 10px"
          >
            <el-option
              v-for="item in QCPlanItem.inside_body_plan.plan_detail_items"
              :key="item.goods_id"
              :label="item.goods_name"
              :value="item.goods_id"
            >
            </el-option>
          </el-select>
          <el-input
            v-if="buyWay2 === '1' || buyWay2 === '2'"
            v-model="QCTime1"
            @input="changeQCTime1"
            size="mini"
            style="width: 210px; margin-bottom: 10px"
          >
            <template slot="append">次</template>
          </el-input>
          <div
            v-if="buyWay2 === '1'"
            style="font-size: 14px; line-height: 20px; padding-left: 10px"
          >
            <div
              v-for="(item, index) in servicePackage.buy_options"
              :key="index"
            >
              {{ item.discount_rate }}折 {{ item.times }}次
            </div>
          </div>
          <div v-if="buyWay2 === '2'">
            <div class="label">最低折扣</div>
            <el-input
              v-model="QCDiscount"
              @input="changeQCDiscount"
              size="mini"
              style="width: 210px; margin-bottom: 5px"
            >
              <template slot="append">折</template>
            </el-input>
            <span style="display: block; font-size: 14px; color: #ff2a3a"
              >最低改价折扣为{{
                $public.cheng(servicePackage.discount_rate, 100)
              }}折</span
            >
          </div>
        </div>
      </div>
      <div class="R">
        <div>
          <el-table
            :stripe="true"
            :data="detail.list"
            style="width: 100%"
            :ref="'table'"
            default-expand-all
          >
            <el-table-column type="expand" width="50">
              <template slot-scope="scope">
                <el-table
                  border
                  :data="scope.row.planGoods"
                  :ref="'table' + scope.$index"
                >
                  <el-table-column label="名称" prop="goodsName" width="200">
                    <template slot-scope="props">
                      {{ props.row.goodsName }}
                    </template>
                  </el-table-column>
                  <el-table-column label="规格" prop="skuValue" width="100">
                  </el-table-column>
                  <el-table-column label="数量" prop="num" width="80">
                    <template slot-scope="props">
                      {{ props.row.num }}
                    </template>
                  </el-table-column>
                  <el-table-column label="单位" prop="unit" width="80">
                  </el-table-column>
                  <el-table-column label="单价" prop="originalPrice">
                  </el-table-column>
                  <el-table-column label="小计">
                    <template slot-scope="props">
                      {{ props.row.totalMoney }}
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column label="计划名称" width="150" prop="planName">
            </el-table-column>
            <el-table-column label="计划日期">
              <template slot-scope="scope">
                <div>{{ $public.FTime(scope.row.planDate, "YYYY-MM-DD") }}</div>
              </template>
            </el-table-column>
            <el-table-column label="距离下一次计划" prop="intervalDays">
            </el-table-column>
            <el-table-column label="金额" prop="planMoney"> </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 最新体重
      newestWeight: "",
      // 销售人员
      saleManIdList: [],
      staffList: [],
      // 疫苗或驱虫
      type: "YM",
      buyWay1: "0",
      buyWay2: "0",
      // 套餐
      serviceId: "",
      servicePackage: {
        vaccine_plan: {},
        rabies_vaccine_plan: {},
        additional_enhance_needle: {},
        additional_medical_service_plan: {},
        discount_rate: 0,
        buy_options: [],
        plan_items: [],
        min_price: 0,
        max_price: 0,
      },
      YMList: [],
      QCList: [],
      // 疫苗
      vaccine_plan: "",
      rabies_vaccine_plan: "",
      additional_enhance_needle: "",
      additional_medical_service_plan: "",
      free1: true,
      free2: true,
      YMDiscount: "88",
      YMCustomPrice: "",
      // 驱虫
      QCPlanItem: null,
      inside: "",
      outside: "",
      zengTime: 3,
      QCTime1: "1",
      QCTime2: "1",
      QCDiscount: "88",
      // 疫苗驱虫详情
      detail: { list: [] },
      YMGroupTypeList: [],
      QCGroupTypeList: [],
      must_use1:0,//否 1是 体内
      must_use2:0,//否 1是
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
    addParams() {
      return this.$store.state.ymqc.addParams;
    },
    money() {
      return this.$store.state.ymqc.money;
    },
  },
  watch: {
    curPetId() {
      this.newestWeight = this.curPetInfo.weight;
      this.type = "YM";
      this.serviceId = "";
      this.addParams.type = this.type;
      this.addParams.newestWeight = Number(this.newestWeight);
      this.$store.commit("ymqc/set_addParams", this.addParams);
      this.getGroupTypeList();
    },
  },
  mounted() {
    this.getStaffList();
    // this.getQCList();
    this.newestWeight = this.curPetInfo.weight;
    this.getGroupTypeList();
    this.addParams.newestWeight = Number(this.newestWeight);
    this.$store.commit("ymqc/set_addParams", this.addParams);
    this.$store.state.mendian.userController.map((controller) => {
      if (controller.invitationType === 3 && controller.userId.length > 0) {
        this.saleManIdList = [controller.userId + "," + controller.userName];
      }
    });
    console.log(this.userInfo,"--------++++++");
  },
  methods: {
    back() {
      this.$store.commit("ymqc/set_type", "list");
    },
    // 体重
    changeNewestWeight() {
      this.newestWeight = this.$public.replaceGoodsDosage(this.newestWeight);
      this.addParams.newestWeight = Number(this.newestWeight);
      this.$store.commit("ymqc/set_addParams", this.addParams);
      if (this.type === "YM") {
        this.getYMList();
      } else {
        this.QCPlanItem = {
          _id: "",
          weight_model: {},
          inside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
          outside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
        };
        this.getQCList();
      }
      this.serviceId = "";
      // this.changeServiceId();
    },
    // 类型
    changeType() {
      if (this.type === "YM") {
     
        this.buyWay1 = this.YMGroupTypeList[0].value;
        this.getYMList();
      } else {
        this.buyWay2 = this.QCGroupTypeList[0].value;
        this.QCPlanItem = {
          _id: "",
          weight_model: {},
          inside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
          outside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
        };
        this.getQCList();
      }
      this.serviceId = "";
      // this.changeServiceId();
      this.addParams.type = this.type;
      this.$store.commit("ymqc/set_addParams", this.addParams);
    },
    // 类型
    changeBuyWay() {
      if (this.type === "QC") {
        this.getQCList();
      } else {
        this.getYMList();
      }
      this.serviceId = "";
    },
    // 改变服务
    changeServiceId() {
    
      if (this.type === "YM") {
        this.vaccine_plan = "";
        this.rabies_vaccine_plan = "";
        this.additional_enhance_needle = "";
        this.additional_medical_service_plan = "";
        this.YMDiscount = "88";
        this.servicePackage = this.$public.getMatchingItem(
          this.YMList,
          "groupId",
          this.serviceId
        );
        console.log(this.servicePackage,"this.servicePackage");
        if (this.servicePackage.additional_enhance_needle.charge_status === 1) {
          this.free1 = false;
        } else {
          this.free1 = true;
        }
        if (
          this.servicePackage.additional_medical_service_plan.charge_status ===
          1
        ) {
          this.free2 = false;
        } else {
          this.free2 = true;
        }
        this.addParams.servicePackage = this.servicePackage;
        this.YMCustomPrice = this.servicePackage.max_price;
        this.$store.commit("ymqc/set_addParams", this.addParams);
      } else {
       
        // this.getQCList();
        console.log(111);
        this.inside = "";
        this.outside = "";
        this.zengTime = 3;
        this.QCTime1 = "1";
        this.QCTime2 = "1";
        this.QCDiscount = "88";
        this.servicePackage = this.$public.getMatchingItem(
          this.QCList,
          "groupId",
          this.serviceId
        );
        console.log(this.servicePackage);
        if(this.servicePackage){
           this.must_use1=this.servicePackage.plan_items[0].inside_body_plan.must_use
        this.must_use2=this.servicePackage.plan_items[0].outside_body_plan.must_use
        }
        this.addParams.servicePackage = this.servicePackage;
       
        let QCPlanItem = {
          _id: "",
          weight_model: {},
          inside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
          outside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
        };
        for (let i = 0; i < this.servicePackage.plan_items.length; i++) {
          let item = this.servicePackage.plan_items[i];
          if (
            item.weight_model.min_weight <= Number(this.newestWeight) &&
            Number(this.newestWeight) <= item.weight_model.max_weight
          ) {
            QCPlanItem = item;
          }
        }
        this.QCPlanItem = QCPlanItem;
        this.$store.commit("ymqc/set_addParams", this.addParams);
        // this.$store.commit("ymqc/set_detail", this.detail);
        
      }
     
    },
    // 疫苗
    changeVaccine_plan() {
      this.YMPreview();
    },
    changeRabies_vaccine_plan() {
      this.YMPreview();
    },
    changeAdditional_enhance_needle() {
      this.YMPreview();
    },
    changeAdditional_medical_service_plan() {
      this.YMPreview();
    },
    changeFree1() {
      this.YMPreview();
    },
    changeFree2() {
      this.YMPreview();
    },
    changeYMDiscount() {
      this.YMDiscount = this.$public.FInt(this.YMDiscount);
      this.YMPreview();
    },
    changeYMCustomPrice() {
      this.YMCustomPrice = this.$public.FInt(this.YMCustomPrice);
      this.detail = { list: [] };
      this.$store.commit("ymqc/set_detail", this.detail);
      if (
        this.YMCustomPrice < this.servicePackage.min_price ||
        this.YMCustomPrice > this.servicePackage.max_price
      ) {
        return;
      } else {
        this.YMPreview();
      }
    },
    // 驱虫
    changeInside() {
      this.QCPreview();
    },
    changeOutside() {
      this.QCPreview();
    },
    changeZengTime() {
      this.QCPreview();
    },
    changeQCTime1() {
      this.QCTime1 = this.$public.FInt(this.QCTime1);
      this.QCPreview();
    },
    changeQCTime2() {
      this.QCTime2 = this.$public.FInt(this.QCTime2);
      this.QCPreview();
    },
    changeQCDiscount() {
      this.QCDiscount = this.$public.FInt(this.QCDiscount);
      this.QCPreview();
    },
    // 预览
    YMPreview() {
      let vaccinePlan = null,
        rabiesVaccinePlan = null,
        additionalMedicalServicePlan = null,
        additionalEnhanceNeedlePlan = null;
      if (this.vaccine_plan) {
        let goods = this.$public.getMatchingItem(
          this.servicePackage.vaccine_plan.use_items,
          "goods_id",
          this.vaccine_plan
        );
        vaccinePlan = {
          planName: this.servicePackage.vaccine_plan.plan_name,
          planCount: this.servicePackage.vaccine_plan.use_count,
          intervalDays: this.servicePackage.vaccine_plan.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: [this.FPlanItem(goods)],
        };
      } else {
        return;
      }
      if (this.rabies_vaccine_plan) {
        let goods = this.$public.getMatchingItem(
          this.servicePackage.rabies_vaccine_plan.use_items,
          "goods_id",
          this.rabies_vaccine_plan
        );
        rabiesVaccinePlan = {
          planName: this.servicePackage.rabies_vaccine_plan.plan_name,
          planCount: this.servicePackage.rabies_vaccine_plan.use_count,
          intervalDays: this.servicePackage.rabies_vaccine_plan.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: [this.FPlanItem(goods)],
        };
      }
      // else {
      //   return;
      // }
      console.log(this.additional_enhance_needle);
      if (!this.$public.isNull(this.additional_enhance_needle)) {
        let goodsItem = [];
        for (let i = 0; i < this.additional_enhance_needle.length; i++) {
          let goods = this.$public.getMatchingItem(
            this.servicePackage.additional_enhance_needle.use_items,
            "goods_id",
            this.additional_enhance_needle[i]
          );
          goodsItem.push(this.FPlanItem(goods));
        }
        additionalMedicalServicePlan = {
          planName: this.servicePackage.additional_enhance_needle.plan_name,
          planCount: this.servicePackage.additional_enhance_needle.use_count,
          intervalDays:
            this.servicePackage.additional_enhance_needle.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: goodsItem,
        };
      }
      if (!this.$public.isNull(this.additional_medical_service_plan)) {
        let goodsItem = [];
        for (let i = 0; i < this.additional_medical_service_plan.length; i++) {
          let goods = this.$public.getMatchingItem(
            this.servicePackage.additional_medical_service_plan.use_items,
            "goods_id",
            this.additional_medical_service_plan[i]
          );
          goodsItem.push(this.FPlanItem(goods));
        }
        additionalEnhanceNeedlePlan = {
          planName:
            this.servicePackage.additional_medical_service_plan.plan_name,
          planCount:
            this.servicePackage.additional_medical_service_plan.use_count,
          intervalDays:
            this.servicePackage.additional_medical_service_plan.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: goodsItem,
        };
      }
      let customPrice = 0;
      if (this.buyWay1 === "2") {
        if (this.$public.isNull(this.YMCustomPrice)) {
          customPrice = 0;
        } else {
          customPrice = Number(this.YMCustomPrice);
          if (
            customPrice < this.servicePackage.min_price ||
            customPrice > this.servicePackage.max_price
          ) {
            this.$message({
              message: "自定义价格不是有效值",
              type: "error",
            });
            return;
          }
        }
      } else {
        customPrice = 0;
      }
      let params = {
        groupId: this.servicePackage.groupId,
        customPrice: customPrice,
        vaccinePlan: vaccinePlan,
        rabiesVaccinePlan: rabiesVaccinePlan,
        additionalMedicalServicePlan: additionalEnhanceNeedlePlan,
        additionalEnhanceNeedlePlan: additionalMedicalServicePlan,
      };
      if (this.buyWay1 === "0") {
        if (params.additionalEnhanceNeedlePlan !== null)
          params.additionalEnhanceNeedlePlan.isFree = this.free1;
        if (params.additionalMedicalServicePlan !== null)
          params.additionalMedicalServicePlan.isFree = this.free2;
      } else if (this.buyWay1 === "1") {
        if (params.vaccinePlan !== null)
          params.vaccinePlan.rate = this.$public.cheng(
            this.servicePackage.discount_rate,
            100
          );
        if (params.rabiesVaccinePlan !== null)
          params.rabiesVaccinePlan.rate = this.$public.cheng(
            this.servicePackage.discount_rate,
            100
          );
        if (params.additionalEnhanceNeedlePlan !== null)
          params.additionalEnhanceNeedlePlan.isFree = this.free1;
        if (params.additionalMedicalServicePlan !== null)
          params.additionalMedicalServicePlan.isFree = this.free2;
      } else {
        // if(params.vaccinePlan!==null) params.vaccinePlan.rate = this.YMDiscount?Number(this.YMDiscount):100;
        // if(params.rabiesVaccinePlan!==null) params.rabiesVaccinePlan.rate = this.YMDiscount?Number(this.YMDiscount):100;
        if (params.additionalEnhanceNeedlePlan !== null)
          params.additionalEnhanceNeedlePlan.isFree = this.free1;
        if (params.additionalMedicalServicePlan !== null)
          params.additionalMedicalServicePlan.isFree = this.free2;
      }
      let loading = this.$loading();
      this.$http
        .post("/api/MedicalPackage/Vaccine/Preview", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.detail = res.data;
            this.$store.commit("ymqc/set_detail", this.detail);
          }
        });
    },
    QCPreview() {
      let outsidePlan = null,
        insidePlan = null;
      if (this.outside) {
        let goods = this.$public.getMatchingItem(
          this.QCPlanItem.outside_body_plan.plan_detail_items,
          "goods_id",
          this.outside
        );
        outsidePlan = {
          planName: this.QCPlanItem.outside_body_plan.plan_name,
          planCount: 1,
          intervalDays: this.QCPlanItem.outside_body_plan.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: [this.FPlanItem(goods)],
        };
      }  if (this.inside) {
        let goods = this.$public.getMatchingItem(
          this.QCPlanItem.inside_body_plan.plan_detail_items,
          "goods_id",
          this.inside
        );
        insidePlan = {
          planName: this.QCPlanItem.inside_body_plan.plan_name,
          planCount: 1,
          intervalDays: this.QCPlanItem.inside_body_plan.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: [this.FPlanItem(goods)],
        };
      }
      let params = {
        groupId: this.servicePackage.groupId,
        outsidePlan: outsidePlan,
        insidePlan: insidePlan,
      };
      if (this.buyWay2 === "0") {
        let zeng = this.$public.getMatchingItem(
          this.servicePackage.buy_options,
          "times",
          this.zengTime
        );
        if (params.insidePlan !== null) {
          params.insidePlan.planCount = zeng.give_times;
          params.insidePlan.isFree = true;
        }
        if (params.outsidePlan !== null) {
          params.outsidePlan.planCount = zeng.times;
          params.outsidePlan.isFree = false;
        }
      } else if (this.buyWay2 === "1") {
        if (params.insidePlan !== null) {
          params.insidePlan.planCount = this.QCTime1;
          params.insidePlan.rate = this.FRate(
            this.QCTime1,
            this.servicePackage.buy_options
          );
        }
        if (params.outsidePlan !== null) {
          params.outsidePlan.planCount = this.QCTime2;
          params.outsidePlan.rate = this.FRate(
            this.QCTime2,
            this.servicePackage.buy_options
          );
        }
      }else{
        if (params.insidePlan !== null) {
          params.insidePlan.planCount = this.QCTime1;
          params.insidePlan.rate = Number(this.QCDiscount);
        }
        if (params.outsidePlan !== null) {
          params.outsidePlan.planCount = this.QCTime2;
          params.outsidePlan.rate = Number(this.QCDiscount);
        }
      } 
      console.log(params,"params");
      let loading = this.$loading();
      this.$http
        .post("/api/MedicalPackage/Deworming/Preview", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.detail = res.data;
            this.$store.commit("ymqc/set_detail", this.detail);
          }
        });
        
    },
    FPlanItem(obj) {
      if (obj.goods_type === 1) {
        let a = {
          goodsId: obj.goods_id,
          goodsName: obj.goods_name,
          goodsType: obj.goods_type,
          brand: obj.brand_name,
          categoryId: obj.model.category_info._id,
          categoryName: obj.model.category_info.name,
          skus: "",
          skuValue: obj.model.old_packinfo_info.sku_value,
          unitId: "",
          unit: obj.model.old_packinfo_info.in_unit,
          outUnit: obj.model.old_packinfo_info.unit,
          originalPrice: this.$public.getCFPrice(
            obj.model.medical_ext_info.allow_wholesale,
            obj.model.old_packinfo_info.in_exchanage,
            obj.model.pprice
          ),
          price: this.$public.getCFPrice(
            obj.model.medical_ext_info.allow_wholesale,
            obj.model.old_packinfo_info.in_exchanage,
            obj.model.pprice
          ),
          num: obj.use_num,
          activityId: "",
          activityName: "",
          totalMoney: 0,
          goodsUsage: "",
          goodsDosage: obj.out_num,
          goodsTimes: "",
          remark: "",
          canActivity: false,
          allowWholesale: obj.model.medical_ext_info.allow_wholesale,
          dosageCeiling: obj.model.medical_ext_info.dosage_ceiling,
          dosageCeilingValue: obj.model.medical_ext_info.dosage_ceiling_value,
          countPriceDosage: 0,
          isNeedCode: obj.use_consumableMaterial_status, // 是否有耗材
        };
        return a;
      } else {
        let skuItem = {};
        for (let i = 0; i < obj.model.serviceItems.length; i++) {
          let sku = obj.model.serviceItems[i];
          if (obj.sku_id === sku.service_objectId) {
            skuItem = sku;
          }
        }
        let a = {
          goodsId: obj.goods_id,
          goodsName: obj.goods_name,
          goodsType: obj.goods_type,
          brand: obj.brand_name,
          categoryId: obj.model.category_info._id,
          categoryName: obj.model.category_info.name,
          skus: skuItem.service_objectId,
          skuValue: skuItem.extend_attr + " " + skuItem.service_objectName,
          unitId: "",
          unit: skuItem.frequency_text,
          outUnit: "",
          originalPrice: skuItem.price,
          price: skuItem.price,
          num: obj.use_num,
          activityId: "",
          activityName: "",
          totalMoney: 0,
          goodsUsage: "",
          goodsDosage: 0,
          goodsTimes: "",
          remark: "",
          canActivity: false,
          allowWholesale: 1,
          dosageCeiling: 0,
          dosageCeilingValue: 0,
          countPriceDosage: 0,
          isNeedCode: obj.use_consumableMaterial_status, // 是否有耗材
        };
        return a;
      }
    },
    FRate(t, obj) {
      t = Number(t);
      let index = -1;
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].times > t) {
          index = i;
          break;
        }
      }
      if (index === 0) {
        return 100;
      } else if (index === -1) {
        return this.$public.cheng(obj[obj.length - 1].discount_rate, 100);
      } else {
        return this.$public.cheng(obj[index - 1].discount_rate, 100);
      }
    },
    // 销售人员
    changeSaleManIdList() {
      console.log(this.saleManIdList);
      this.addParams.saleManIdList = this.saleManIdList;
      this.$store.commit("ymqc/set_addParams", this.addParams);
    },
    getStaffList() {
      let params = {
        keyword: "",
        pageIndex: 1,
        pageSize: 500,
      };
      this.$http.get("/api/Staff/MedicalStaffList", params).then((res) => {
        if (res.code == 0) {
     
          this.staffList = res.data.data;
        }
      });
    },
    // 获取列表
    getYMList() {
      let params = {
        keyword: "",
        applytype: "0," + this.curPetInfo.apply_type.value,
        categoryId: "",
        buyWay: this.buyWay1,
        pageIndex: 1,
        pageSize: 100,
      };
      let loading = this.$loading();
      this.$http.post("/api/Product/Vaccine/List", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.YMList = res.data.data;
          if (this.$public.isNull(this.YMList)) {
            this.serviceId = "";
            this.servicePackage = {
              vaccine_plan: {},
              rabies_vaccine_plan: {},
              additional_enhance_needle: {},
              additional_medical_service_plan: {},
              discount_rate: 0,
              buy_options: [],
              plan_items: [],
              min_price: 0,
              max_price: 0,
            };
          } else {
            this.serviceId = this.YMList[0].groupId;
            this.servicePackage = this.YMList[0];
          }
          this.addParams.servicePackage = this.servicePackage;
          // this.addParams.servicePackage = this.$public.getMatchingItem(this.YMList,'groupId',this.serviceId)
          this.$store.commit("ymqc/set_addParams", this.addParams);
          this.detail = { list: [] };
          this.$store.commit("ymqc/set_detail", this.detail);
          this.changeServiceId();
        }
      });
    },
    getQCList() {
      let hsPetMaster=0
      if(this.userInfo.pet_count&&this.userInfo.pet_count.hsTotal>0){
        hsPetMaster=1
    }else if(this.userInfo.pet_count&&this.userInfo.pet_count.hsTotal==0){
      hsPetMaster=2
    }
    

      let params = {
        keyword: "",
        applytype: "0," + this.curPetInfo.apply_type.value,
        categoryId: "",
        buyWay: this.buyWay2,
        pageIndex: 1,
        pageSize: 100,
        hsPetMaster:hsPetMaster,
        grade:this.userInfo.club_card. surplus_day
      };
      let loading = this.$loading();
      this.$http.post("/api/Product/Deworming/List", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.QCList = res.data.data||[];
          console.log( this.QCList," this.QCList");
          // if(this.type==="QC"){
          // 	this.serviceId = this.QCList[0].groupId
          // 	this.servicePackage = this.QCList[0]
          // 	for(let i=0;i<this.servicePackage.plan_items.length;i++){
          // 		let item = this.servicePackage.plan_items[i];
          // 		if(item.weight_model.min_weight<=Number(this.newestWeight)&&Number(this.newestWeight)<item.weight_model.max_weight){
          // 			this.QCPlanItem = item;
          // 		}
          // 	}
          // }
          if (this.$public.isNull(this.QCList)) {
            this.serviceId = "";
            this.servicePackage = {
              vaccine_plan: {},
              rabies_vaccine_plan: {},
              additional_enhance_needle: {},
              additional_medical_service_plan: {},
              discount_rate: 0,
              buy_options: [],
              plan_items: [],
              min_price: 0,
              max_price: 0,
            };
            this.QCPlanItem = {
              _id: "",
              weight_model: {},
              inside_body_plan: {
                plan_name: "",
                must_use: 1,
                next_plan_days: 1,
                plan_detail_items: [],
              },
              outside_body_plan: {
                plan_name: "",
                must_use: 1,
                next_plan_days: 1,
                plan_detail_items: [],
              },
            };
          } else {
            this.serviceId = this.QCList[0].groupId;
            this.servicePackage = this.QCList[0];
            for (let i = 0; i < this.servicePackage.plan_items.length; i++) {
              let item = this.servicePackage.plan_items[i];
              if (
                item.weight_model.min_weight <= Number(this.newestWeight) &&
                Number(this.newestWeight) <= item.weight_model.max_weight
              ) {
                this.QCPlanItem = item;
              }
            }
          }
          // this.addParams.servicePackage = this.$public.getMatchingItem(this.QCList,'groupId',this.serviceId)
          this.addParams.servicePackage = this.servicePackage;
          this.$store.commit("ymqc/set_addParams", this.addParams);
          this.detail = { list: [] };
          this.$store.commit("ymqc/set_detail", this.detail);
          this.changeServiceId();
        }
      });
    },
    getGroupTypeList() {
      this.$http
        .get(
          process.env.VUE_APP_Url2 +
            "api/product/group/Vaccine/buyway/available"
        )
        .then((res) => {
          if (res.code == 0) {
            this.YMGroupTypeList = res.data;
            this.buyWay1 = this.YMGroupTypeList[0].value;
            this.getYMList();
          }
        });
      this.$http
        .get(
          process.env.VUE_APP_Url2 +
            "api/product/group/Deworming/buyway/available"
        )
        .then((res) => {
          if (res.code == 0) {
            this.QCGroupTypeList = res.data;
            this.buyWay2 = this.QCGroupTypeList[0].value;
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
.panel_shouyin {
  height: 100%;
  padding-bottom: 60px;
  box-sizing: border-box;
  position: relative;
  .titleLine {
    width: 100%;
    background-color: #fff;
    height: 44px;
    padding: 8px 8px;
    box-sizing: border-box;
    margin-bottom: 4px;
    position: absolute;
    z-index: 1;
  }
  .con {
    display: flex;
    padding: 12px 0px 100px 0px;
    background-color: #fff;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    .L {
      width: 248px;
      border-right: 1px solid #f5f5f5;
      flex-shrink: 0;
      box-sizing: border-box;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 12px 20px 0;
      .label {
        font-size: 14px;
        padding-bottom: 10px;
        color: $fontColor;
      }
      .xmjBox {
        .xmjItem {
          position: relative;
          width: 123px;
          box-sizing: border-box;
          height: 40px;
          text-align: center;
          line-height: 38px;
          color: #000;
          font-size: 14px;
          background-color: #e8e8e8;
          border-radius: 2px;
          margin-top: 15px;
          margin-left: 20px;
          border: 1px solid transparent;
          cursor: pointer;
          &.active {
            background-color: #e3f2ff;
            border-color: #1890ff;
          }
          .checked {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 26px;
            height: 13px;
            text-align: center;
            color: #fff;
          }
        }
      }
      ::v-deep .el-select__tags-text {
        display: inline-block;
        max-width: 148px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      ::v-deep .el-tag__close.el-icon-close {
        top: -7px;
      }
    }
    .R {
      width: 100%;
      height: 100%;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 4px;
        // height: 4px;
      }
      .col {
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        .RLabel {
          font-size: 14px;
          color: #6e6e6e;
          text-align: right;
          line-height: 28px;
        }
      }
      .roomBox {
        display: flex;
        padding: 10px 90px;
        flex-wrap: wrap;
        .room {
          position: relative;
          width: 195px;
          height: 110px;
          border: 1px solid #ccc;
          box-sizing: border-box;
          background-color: #e8e8e8;
          margin: 10px 10px;
          text-align: center;
          cursor: pointer;
          padding: 0 20px;
          .mask {
            position: absolute;
            top: -2px;
            left: -2px;
            z-index: 10;
            width: 195px;
            height: 110px;
            background-color: rgba(0, 0, 0, 0.5);
          }
          .tip {
            position: absolute;
            top: -2px;
            left: -2px;
            width: 55px;
            height: 20px;
            text-align: center;
            color: #fff;
            background-color: #ffae11;
            font-size: 12px;
            line-height: 20px;
          }
          .checked {
            position: absolute;
            right: -1px;
            bottom: -1px;
            width: 40px;
            height: 18px;
            text-align: center;
            color: #fff;
          }
          .roomName {
            font-size: 16px;
            color: #262626;
            padding-top: 28px;
            line-height: 20px;
            height: 40px;
          }
          .roomPrice {
            font-size: 14px;
            color: #262626;
            padding-top: 10px;
          }
          &.active {
            background-color: #ffeac2;
            border-color: #ffae11;
          }
        }
      }
    }
  }
}
</style>
